import { View } from 'react-native';
import { StyleSheet } from 'react-native-unistyles';
import getOffsetColor from '@/utils/getOffsetColor';
import { selectionAsync } from '@/utils/Haptics';
import palette from '@/utils/palette';
import Box from '../UI/Box';
import Icon from '../Unistyles/Icon';
import Pressable from '../Unistyles/Pressable';

interface ColorPickerProps {
  onPress(color: string): void;
  value?: string;
}

export default function ColorPicker({ onPress, value }: ColorPickerProps) {
  return (
    <Box direction="horizontal" style={style.container} testID="ColorPicker">
      {palette.map((color) => {
        const selected = value === color;

        return (
          <Pressable
            accessibilityLabel={`Choose ${color}`}
            accessibilityState={{ selected }}
            key={color}
            testID="ColorPickerItem"
            onPress={() => {
              selectionAsync();
              onPress(color);
            }}
            styleOverride={({ pressed }) => [
              style.item(color),
              selected && style.selected,
              pressed && style.active(color),
            ]}
          >
            {selected ? (
              <View pointerEvents="none" style={style.selectedIndicator}>
                <Icon name="checkmark" size="lg" variant="white" />
              </View>
            ) : null}
          </Pressable>
        );
      })}
    </Box>
  );
}

const style = StyleSheet.create((theme) => ({
  container: {
    width: '100%',
    height: theme.size(10),
    borderRadius: theme.borderRadius.xl,
    overflow: 'hidden',
  },
  item: (color: string) => ({
    alignItems: 'center',
    flex: 1,
    backgroundColor: color,
    height: theme.size(10),
    justifyContent: 'center',
    width: theme.size(10),
    _web: {
      _hover: {
        backgroundColor: getOffsetColor(color, false, 0.5),
      },
    },
  }),
  active: (color: string) => ({
    backgroundColor: getOffsetColor(color, false, 1),
  }),
  selected: {
    zIndex: 1,
  },
  selectedIndicator: {
    alignItems: 'center',
    backgroundColor: 'rgba(0, 0, 0, 0.32)',
    borderRadius: theme.borderRadius.full,
    height: theme.size(6),
    justifyContent: 'center',
    width: theme.size(6),
  },
}));
